import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import PendingOrderGrid from './PendingOrderGrid'
import pendingApprovalOperations from '../../../../../../redux/PendingOrder/operations'
import pendingApprovalSelectors from '../../../../../../redux/PendingOrder/selectors'
import userProfileSelectors from '../../../../../../redux/UserProfile/selectors'
import { setOrderId } from 'redux/MyOrder/action';
import Moment from 'moment';
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { useNavigate } from 'react-router-dom';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { getAllRequestTypeList, getAssignedToList, getBuyerNameList, getCostCenterList, getRegionList, getRequestedByList, getStatusList, getUpdatedByList } from 'Store/OrderManagement/OrderGridDropdowns/OrderGridDropdownsAction';
import { GetOnOrderIdClickedUrl, types } from 'client/Components/OrderManagement/mainUtil';
import { setOrderById } from 'Store/OrderManagement/Order/OrderAction'
import { setTransferOrderById } from 'Store/Transfer/Transfer/TransferOrderByIdAction'
import { getFleetProccessingItemStatusList } from 'Store/Component/FleetManagement/FleetManagementAction';
import { getFleetProcessingGridData, getMyOrdersGridData, getPendingOrdersGridData, getAllPendingOrdersGridData } from 'redux/PendingOrder/action';
import { HOME_ACTIVE_MENU } from 'client/utils/constants/homeGridConstants';
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import { useDebounce } from 'client/CommonComponents/CustomDebounce/DebounceHook';
import moment from 'moment';
import { getDispositionChoice } from 'Store/OrderManagement/DispositionChoice/DispositionChoiceAction';
import { setBulkOrderById } from 'Store/OrderManagement/BulkOrderById/BulkOrderByIdAction';
import { CONSTANTS } from 'client/utils/constants';
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch';
import { fetchGridPayload } from 'utils';

const PendingOrderGridContainer = (props: any) => {

  const {
    searchBoxValue,
    dateRange,
    activeMenu,
    myOrdersGridFilters,
    pendingApprovalGridFilters,
    fleetProcessingGridFilters,
    serverTotal,
    selectedAssignedTo,
    allPendingApprovalGridFilters,
    assignedToTemp,
    requestedByTemp,
    regionTemp,
    costCenterTemp,
    updatedByTemp,
    setSelectedDispositionKey,
    selectedDispositionKey,
    dispositionTypeList,
    buyerNameList,
    setSelectedBuyerNameKey,
    selectedBuyerNameKey,
    globalSearchBy,
    serverPageNumber
  } = props
  const [filteredOrderList, setFilteredOrderList] = useState(props?.filteredOrderList || []);
  const dispatch = useDispatch();
  const dispatchSetIsOrderApprovalComplete = pendingApprovalOperations.dispatchSetIsOrderApprovalComplete(dispatch);
  const dispatchGetCartCount = OrderDispatch.dispatchGetCartCount(dispatch);

  const [rowData, setRowData] = useState<any>("");
  const [approvers, setApprovers] = useState(false);
  const [fleetAdmin, setFleetAdmin] = useState(false);
  const navigate = useNavigate();
  const [orderStatusTemp, setOrderStatusTemp] = useState<any>([]);
  const [orderRequestTypeTemp, setOrderRequestTypeTemp] = useState<any>([]);
  const [itemStatusOptions, setItemStatusOptions] = useState<any>([])
  const [paginationData, setPaginationData] = useState<any>({})
  const [gridKey, setGridKey] = useState<number>(0)
  const [pagesCount, setPagesCount] = useState<number>(0)
  const orderDate = useRef<any>(null);
  const updateDate = useRef<any>(null);
  const selectStatus = useRef<any>("");
  const selectRegion = useRef<any>("");
  const selectRequsetType = useRef<any>("");
  const selectPreAuthorizationFlag = useRef<any>("All");
  const selectCostCenter = useRef<any>("");
  const selectUpdatedBy = useRef<any>("");
  const selectAssignedTo = useRef<any>("");
  const selectRequestedBy = useRef<any>("");
  const selectItemStatus = useRef<any>("");
  const selectDispositionType = useRef<any>("");
  const selectBuyerName = useRef<any>('');
  const orderPriceFilterRef = useRef<any>('');
  const [quantityFilter, setQuantityFilter] = useState<any>('')
  const [orderIdFilter, setOrderIdFilter] = useState<any>('')
  const [orderPriceFilter, setOrderPriceFilter] = useState<any>('')
  const [frsOrderNumberFilter, setFrsOrderNumberFilter] = useState<any>('')
  const [commentFilter, setCommentFilter] = useState<any>('')
  const [sortData, setSortData] = useState<any>('')
  const lastCommonSearchSignatureRef = useRef<string | null>(null)
  const lastColumnFilterSignatureRef = useRef<string | null>(null)
  const forceFirstPageForCommonSearchRef = useRef<boolean>(false)
  


  const {
    userDetails,
    orderListGridData,
    allRequestTypeList,
    statusList,
    regionList,
    costCenterList,
    requestedByList,
    updatedByList,
    cartCount,
    itemStatusList,
    isGridDataLoading,
    isDropDownsLoading,
  }: any = useSelector(
    (state: any) => ({
      userDetails: userProfileSelectors.getUserDetails(state),
      orderListGridData: pendingApprovalSelectors.orderListGridData(state),
      allRequestTypeList: state.OrderGridDropdownsReducer.allRequestTypeList,
      statusList: state.OrderGridDropdownsReducer.statusList,
      regionList: state.OrderGridDropdownsReducer.regionList,
      costCenterList: state.OrderGridDropdownsReducer.costCenterList,
      requestedByList: state.OrderGridDropdownsReducer.requestedByList,
      updatedByList: state.OrderGridDropdownsReducer.updatedByList,
      cartCount: state.OrderReducer.cartCount,
      itemStatusList: state?.fleetAdminTaskReducer?.itemStatusList,
      isGridDataLoading: state?.PendingOrder?.isGridDataLoading,
      isDropDownsLoading: state.OrderGridDropdownsReducer.isDropDownsLoading,
    }));

  const onOrderIdClicked = (e: any, row: any) => {
    dispatch(RequisitionAction.setIsEditRequestClick(false))
    dispatch(RequisitionAction.setEditRequestDetails({}))
    dispatch(setOrderById({}));
    dispatch(setTransferOrderById({}))
    dispatch(TransferAction.setAfeOrderByIdData({}))
    dispatch(setBulkOrderById({}))
    e.preventDefault();
    const orderId = row?.rowData?.orderId
    const orderStatus = row?.rowData?.status
    const orderType = row?.rowData?.orderType

    dispatch(RequisitionAction.setIsChangesOccured(false));
    dispatch(TransferAction.setIsChangesOccuredInCart(false))
    dispatch(RequisitionAction.setOrderEditNavigateChange("Home"));
    dispatch(setOrderId(orderId));

    if (orderStatus === "Unsubmitted") {
      if (types.includes(orderType)) {
        dispatch(TransferAction.setIsEditOrder(true))
      } else {
        dispatch(RequisitionAction.setIsEditOrder(true))
      }
    } else {
      dispatchSetIsOrderApprovalComplete(false)
    }

    setRowData(row?.rowData);
  }

  useEffect(() => {
    let navigationUrl : any
    if (rowData?.orderId && !rowData?.isBulkOrder) {
      navigationUrl = GetOnOrderIdClickedUrl(rowData?.status, rowData?.orderType, rowData?.orderId, rowData?.isBulkOrder, 'home', props?.activeMenu)
    }else if(rowData?.orderId && rowData?.isBulkOrder){
      navigationUrl =  GetOnOrderIdClickedUrl(rowData?.status, CONSTANTS?.BULK_ORDER_GRID, rowData?.orderId, rowData?.isBulkOrder, 'home', props?.activeMenu)
    }
    navigate(navigationUrl);
  }, [rowData])

  useEffect(() => {
    userDetails?.emailId && dispatchGetCartCount(userDetails?.emailId);
    !(allRequestTypeList?.length > 0) && dispatch(getAllRequestTypeList())
    !(statusList?.length > 0) && dispatch(getStatusList())
    !(regionList?.length > 0) && dispatch(getRegionList())
    !(costCenterList?.length > 0) && dispatch(getCostCenterList())
    !(requestedByList?.length > 0) && dispatch(getRequestedByList())
    !(updatedByList?.length > 0) && dispatch(getUpdatedByList())
    !(itemStatusList?.length > 0) && dispatch(getFleetProccessingItemStatusList())
    !(dispositionTypeList?.length > 0) && dispatch(getDispositionChoice())
    !(buyerNameList?.length > 0) && dispatch(getBuyerNameList())
    dispatch(getAssignedToList())
  }, [])

  const getFilteredValues = () => {
    let filteredValues: any = [];
    if (orderDate.current != null) {
      filteredValues.push({ 'field': 'orderDate', 'value': moment(new Date(orderDate.current)).format('YYYY-MM-DD') })
    }
    if (updateDate.current != null) {
      filteredValues.push({ 'field': 'updatedDate', 'value': moment(new Date(updateDate.current)).format('YYYY-MM-DD') })
    }
    if (selectStatus.current != "") {
      filteredValues.push({ 'field': 'status', 'value': selectStatus.current })
    }
    if (selectRegion.current != "") {
      const findValue = regionTemp?.find((item: any) => item.label === selectRegion.current)
      filteredValues.push({ 'field': 'regionName', 'value': findValue.value })
    }
    if (selectUpdatedBy.current != "") {
      const findValue = updatedByTemp?.find((item: any) => item.label === selectUpdatedBy.current)
      filteredValues.push({ 'field': 'updatedBy', 'value': findValue?.value })
    }
    if (selectAssignedTo.current != "") {
      const findValue = assignedToTemp?.find((item: any) => item.label === selectAssignedTo.current)
      filteredValues.push({ 'field': 'assignedTo', 'value': findValue?.value })
    }
    if (selectRequestedBy.current != "") {
      const findValue = requestedByTemp?.find((item: any) => item.label === selectRequestedBy.current)
      filteredValues.push({ 'field': 'requestedBy', 'value': findValue?.value })
    }
    if (selectRequsetType.current != "") {
      filteredValues.push({ 'field': 'orderRequestType', 'value': selectRequsetType.current })
    }
    if (activeMenu == HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
      let val = "";
      if(selectPreAuthorizationFlag.current == "Yes" && selectPreAuthorizationFlag.current != ""){
        val = "true"
      }else if(selectPreAuthorizationFlag.current == "No" && selectPreAuthorizationFlag.current != ""){
        val = "false"
      }
      filteredValues.push({ 'field': 'isApprovalOverride', 'value': val })
    }
    if (selectCostCenter.current != "") {
      const findValue = costCenterTemp?.find((item: any) => item.label === selectCostCenter.current)
      filteredValues.push({ 'field': 'costCenter', 'value': findValue?.value })
    }
    if (selectItemStatus.current != "") {
      filteredValues.push({ 'field': 'fleetItemStatus', 'value': selectItemStatus.current })
    }
    if(selectDispositionType.current != ""){
      filteredValues.push({ 'field': 'dispositionType', 'value': selectedDispositionKey })
    }
    if(selectBuyerName.current != ""){
      filteredValues.push({ 'field': 'buyerName', 'value': selectedBuyerNameKey })
    }
    if (quantityFilter != "" && quantityFilter) {
      filteredValues.push({ 'field': 'quantity', 'value': quantityFilter })
    }
    if (orderIdFilter != "" && orderIdFilter) {
      filteredValues.push({ 'field': 'orderId', 'value': orderIdFilter })
    }
    if (orderPriceFilterRef.current != "" && orderPriceFilterRef.current) {
      filteredValues.push({ 'field': 'orderPrice', 'value': orderPriceFilterRef.current })
    }
    if (frsOrderNumberFilter != "" && frsOrderNumberFilter) {
      filteredValues.push({ 'field': 'frsOrderNumber', 'value': frsOrderNumberFilter })
    }
    if (commentFilter != "" && commentFilter) {
      filteredValues.push({ 'field': 'comment', 'value': commentFilter })
    }
    return filteredValues;
  }

  const debounceObject = [
    paginationData, activeMenu, searchBoxValue, dateRange, orderDate, updateDate, selectStatus, selectRegion,
    selectUpdatedBy, selectAssignedTo, selectRequestedBy, selectRequsetType, selectPreAuthorizationFlag, selectCostCenter, selectItemStatus,
      quantityFilter, orderIdFilter, orderPriceFilter, frsOrderNumberFilter, commentFilter, sortData, selectedAssignedTo, selectDispositionType, selectBuyerName
  ]
  const globalDebounce = useDebounce(debounceObject, 500)

  const syncPaginationToFirstPage = useCallback(() => {
    setPaginationData((prev: any) => {
      const nextPaginationData = { ...prev, pageIndex: 0 }

      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ paginationData: nextPaginationData }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ paginationData: nextPaginationData }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ paginationData: nextPaginationData }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ paginationData: nextPaginationData }))
      }

      return nextPaginationData
    })
  }, [dispatch, props?.activeMenu])

  const fetchGridData = (pageOverride?: number) => {
    const normalizedSearchText = `${searchBoxValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = `${JSON.stringify(currentColumnFilters)}::${activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING ? selectedAssignedTo?.value ?? '' : ''}`
    const shouldForceFirstPageForCommonSearch = pageOverride === undefined && forceFirstPageForCommonSearchRef.current
    const resolvedPageNumber = pageOverride !== undefined
      ? pageOverride
      : shouldForceFirstPageForCommonSearch
        ? 1
      : (paginationData?.pageIndex != undefined ? paginationData?.pageIndex + 1 : undefined)
    let payload: any = {
      "pageNumber": resolvedPageNumber,
      "pageSize": paginationData?.pageSize,
      "columnFilters": currentColumnFilters,
      "loggedInMail" : userDetails?.emailId
    }

    payload = fetchGridPayload(payload, dateRange, searchBoxValue, sortData, true, globalSearchBy)

    if(selectedAssignedTo?.label != '' && activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING){
      payload.assignedToFilter = selectedAssignedTo?.value
    }

    lastCommonSearchSignatureRef.current = currentCommonSearchSignature
  lastColumnFilterSignatureRef.current = currentColumnFilterSignature
    forceFirstPageForCommonSearchRef.current = false

    if (userDetails?.emailId && payload.pageNumber && payload.pageSize) {
      if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(getPendingOrdersGridData({ userId: userDetails?.emailId, payload }))
      } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(getFleetProcessingGridData({ payload }))
      } else if (activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(getAllPendingOrdersGridData({ userId: userDetails?.emailId, payload }))
      } else {
        dispatch(getMyOrdersGridData({ userId: userDetails?.emailId, payload }))
      }
    }
  }

  useEffect(() => {
    const normalizedSearchText = `${searchBoxValue ?? ''}`.trim()
    const currentCommonSearchSignature = `${globalSearchBy ?? ''}::${normalizedSearchText}`
    const currentColumnFilters = getFilteredValues()
    const currentColumnFilterSignature = `${JSON.stringify(currentColumnFilters)}::${activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING ? selectedAssignedTo?.value ?? '' : ''}`
    const currentPageIndex = paginationData?.pageIndex ?? 0
    if (lastCommonSearchSignatureRef.current === null || lastColumnFilterSignatureRef.current === null) {
      lastCommonSearchSignatureRef.current = currentCommonSearchSignature
      lastColumnFilterSignatureRef.current = currentColumnFilterSignature
      return
    }
    const hasCommonSearchChanged = currentCommonSearchSignature !== lastCommonSearchSignatureRef.current
    const hasColumnFilterChanged = currentColumnFilterSignature !== lastColumnFilterSignatureRef.current

    if (hasCommonSearchChanged || hasColumnFilterChanged) {
      forceFirstPageForCommonSearchRef.current = true
    }

    if ((hasCommonSearchChanged || hasColumnFilterChanged) && currentPageIndex !== 0) {
      syncPaginationToFirstPage()
      setGridKey((k: number) => k + 1)
    }
  }, [globalDebounce, paginationData?.pageIndex, syncPaginationToFirstPage, activeMenu, selectedAssignedTo?.value])

  useEffect(() => {
    fetchGridData()
  }, [globalDebounce])

  useEffect(() => {
    orderDate.current = null;
    updateDate.current = null;
    selectStatus.current = "";
    selectRegion.current = "";
    selectUpdatedBy.current = "";
    selectAssignedTo.current = "";
    selectRequestedBy.current = "";
    selectRequsetType.current = "";
    selectPreAuthorizationFlag.current = "All";
    selectCostCenter.current = "";
    selectItemStatus.current = "";
    selectDispositionType.current = "";
    selectBuyerName.current = '';
    orderPriceFilterRef.current = '';
    if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      selectCostCenter.current = pendingApprovalGridFilters?.costCenter ?? '';
      selectRegion.current = pendingApprovalGridFilters?.regionName ?? '';
      selectUpdatedBy.current = pendingApprovalGridFilters?.updatedBy ?? '';
      selectAssignedTo.current = pendingApprovalGridFilters?.assignedTo ?? '';
      selectRequestedBy.current = pendingApprovalGridFilters?.requestedBy ?? '';
      selectStatus.current = pendingApprovalGridFilters?.status ?? '';
      selectRequsetType.current = pendingApprovalGridFilters?.orderRequestType ?? '';
      orderPriceFilterRef.current = pendingApprovalGridFilters?.orderPrice ?? '';
      if (pendingApprovalGridFilters?.orderDate) {
        orderDate.current = new Date(pendingApprovalGridFilters?.orderDate);
      } else {
        orderDate.current = null;
      }
      if (pendingApprovalGridFilters?.updatedDate) {
        updateDate.current = new Date(pendingApprovalGridFilters?.updatedDate);
      } else {
        updateDate.current = null
      }
      setQuantityFilter(pendingApprovalGridFilters?.quantity);
      setOrderIdFilter(pendingApprovalGridFilters?.orderId);
      setOrderPriceFilter(pendingApprovalGridFilters?.orderPrice)
      setFrsOrderNumberFilter(pendingApprovalGridFilters?.frsOrderNumber)
      setCommentFilter(pendingApprovalGridFilters?.comment)
      setPaginationData(pendingApprovalGridFilters?.paginationData)
      setSortData(pendingApprovalGridFilters?.sortData)
    }else if (props.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
      selectCostCenter.current = allPendingApprovalGridFilters?.costCenter ?? '';
      selectRegion.current = allPendingApprovalGridFilters?.regionName ?? '';
      selectUpdatedBy.current = allPendingApprovalGridFilters?.updatedBy ?? '';
      selectAssignedTo.current = allPendingApprovalGridFilters?.assignedTo ?? '';
      selectRequestedBy.current = allPendingApprovalGridFilters?.requestedBy ?? '';
      selectStatus.current = allPendingApprovalGridFilters?.status ?? '';
      selectRequsetType.current = allPendingApprovalGridFilters?.orderRequestType ?? '';
      selectPreAuthorizationFlag.current = allPendingApprovalGridFilters?.isApprovalOverride ?? 'All';
      orderPriceFilterRef.current = allPendingApprovalGridFilters?.orderPrice ?? '';
      if (allPendingApprovalGridFilters?.orderDate) {
        orderDate.current = new Date(allPendingApprovalGridFilters?.orderDate);
      } else {
        orderDate.current = null;
      }
      if (allPendingApprovalGridFilters?.updatedDate) {
        updateDate.current = new Date(allPendingApprovalGridFilters?.updatedDate);
      } else {
        updateDate.current = null
      }
      setQuantityFilter(allPendingApprovalGridFilters?.quantity);
      setOrderIdFilter(allPendingApprovalGridFilters?.orderId);
      setOrderPriceFilter(allPendingApprovalGridFilters?.orderPrice)
      setFrsOrderNumberFilter(allPendingApprovalGridFilters?.frsOrderNumber)
      setCommentFilter(allPendingApprovalGridFilters?.comment)
      setPaginationData(allPendingApprovalGridFilters?.paginationData)
      setSortData(allPendingApprovalGridFilters?.sortData)
    } else if (props.activeMenu === HOME_ACTIVE_MENU.MY_ORDERS) {
      selectCostCenter.current = myOrdersGridFilters?.costCenter ?? '';
      selectRegion.current = myOrdersGridFilters?.regionName ?? '';
      selectUpdatedBy.current = myOrdersGridFilters?.updatedBy ?? '';
      selectRequestedBy.current = myOrdersGridFilters?.requestedBy ?? '';
      selectAssignedTo.current = myOrdersGridFilters?.assignedTo ?? '';
      selectStatus.current = myOrdersGridFilters?.status ?? '';
      selectRequsetType.current = myOrdersGridFilters?.orderRequestType ?? '';
      orderPriceFilterRef.current = myOrdersGridFilters?.orderPrice ?? '';
      if (myOrdersGridFilters?.orderDate) {
        orderDate.current = new Date(myOrdersGridFilters?.orderDate);
      } else {
        orderDate.current = null;
      }
      if (myOrdersGridFilters?.updatedDate) {
        updateDate.current = new Date(myOrdersGridFilters?.updatedDate);
      } else {
        updateDate.current = null
      }
      setQuantityFilter(myOrdersGridFilters?.quantity);
      setOrderIdFilter(myOrdersGridFilters?.orderId);
      setOrderPriceFilter(myOrdersGridFilters?.orderPrice)
      setFrsOrderNumberFilter(myOrdersGridFilters?.frsOrderNumber)
      setCommentFilter(myOrdersGridFilters?.comment)
      setPaginationData(myOrdersGridFilters?.paginationData)
      setSortData(myOrdersGridFilters?.sortData)
    } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      selectCostCenter.current = fleetProcessingGridFilters?.costCenter ?? '';
      selectRegion.current = fleetProcessingGridFilters?.regionName ?? '';
      selectUpdatedBy.current = fleetProcessingGridFilters?.updatedBy ?? '';
      selectAssignedTo.current = fleetProcessingGridFilters?.assignedTo ?? '';
      selectRequestedBy.current = fleetProcessingGridFilters?.requestedBy ?? '';
      selectStatus.current = fleetProcessingGridFilters?.status ?? '';
      selectRequsetType.current = fleetProcessingGridFilters?.orderRequestType ?? '';
      selectItemStatus.current = fleetProcessingGridFilters?.fleetItemStatus ?? ''
      selectDispositionType.current = fleetProcessingGridFilters?.dispositionType ?? '';
      selectBuyerName.current = fleetProcessingGridFilters?.buyerName ?? '';
      orderPriceFilterRef.current = fleetProcessingGridFilters?.orderPrice ?? '';
      let dispositionKey = dispositionTypeList?.find((item?: any) => item?.label == fleetProcessingGridFilters?.dispositionType)?.value
      setSelectedDispositionKey(dispositionKey)
      let buyerNameKey = buyerNameList?.find((item?: any) => item?.label == fleetProcessingGridFilters?.buyerName)?.value
      setSelectedBuyerNameKey(buyerNameKey)
      if (fleetProcessingGridFilters?.orderDate) {
        orderDate.current = new Date(fleetProcessingGridFilters?.orderDate);
      } else {
        orderDate.current = null;
      }
      if (fleetProcessingGridFilters?.updatedDate) {
        updateDate.current = new Date(fleetProcessingGridFilters?.updatedDate);
      } else {
        updateDate.current = null
      }
      setQuantityFilter(fleetProcessingGridFilters?.quantity);
      setOrderIdFilter(fleetProcessingGridFilters?.orderId);
      setOrderPriceFilter(fleetProcessingGridFilters?.orderPrice)
      setFrsOrderNumberFilter(fleetProcessingGridFilters?.frsOrderNumber)
      setCommentFilter(fleetProcessingGridFilters?.comment)
      setPaginationData(fleetProcessingGridFilters?.paginationData)
      setSortData(fleetProcessingGridFilters?.sortData)
    }
  }, [props?.activeMenu])

  useEffect(() => {
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setQuantityFilter(pendingApprovalGridFilters?.quantity)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setQuantityFilter(fleetProcessingGridFilters?.quantity)
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      setQuantityFilter(allPendingApprovalGridFilters?.quantity)
    } else {
      setQuantityFilter(myOrdersGridFilters?.quantity)
    }
  }, [pendingApprovalGridFilters?.quantity, myOrdersGridFilters?.quantity, fleetProcessingGridFilters?.quantity, allPendingApprovalGridFilters?.quantity])

  useEffect(() => {
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setOrderIdFilter(pendingApprovalGridFilters?.orderId)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setOrderIdFilter(fleetProcessingGridFilters?.orderId)
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      setOrderIdFilter(allPendingApprovalGridFilters?.orderId)
    } else {
      setOrderIdFilter(myOrdersGridFilters?.orderId)
    }
  }, [pendingApprovalGridFilters?.orderId, myOrdersGridFilters?.orderId, fleetProcessingGridFilters?.orderId, allPendingApprovalGridFilters?.orderId])

  useEffect(() => {
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setOrderPriceFilter(pendingApprovalGridFilters?.orderPrice)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setOrderPriceFilter(fleetProcessingGridFilters?.orderPrice)
    } else if(activeMenu === HOME_ACTIVE_MENU){
      setOrderPriceFilter(allPendingApprovalGridFilters?.orderPrice)
    } else {
      setOrderPriceFilter(myOrdersGridFilters?.orderPrice)
    }
  }, [pendingApprovalGridFilters?.orderPrice, myOrdersGridFilters?.orderPrice, fleetProcessingGridFilters?.orderPrice, allPendingApprovalGridFilters?.orderPrice])

  useEffect(() => {
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setFrsOrderNumberFilter(pendingApprovalGridFilters?.frsOrderNumber)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setFrsOrderNumberFilter(fleetProcessingGridFilters?.frsOrderNumber)
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      setFrsOrderNumberFilter(allPendingApprovalGridFilters?.frsOrderNumber)
    } else {
      setFrsOrderNumberFilter(myOrdersGridFilters?.frsOrderNumber)
    }
  }, [pendingApprovalGridFilters?.frsOrderNumber, myOrdersGridFilters?.frsOrderNumber, fleetProcessingGridFilters?.frsOrderNumber, allPendingApprovalGridFilters?.frsOrderNumber])

  useEffect(() => {
    if (activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      setCommentFilter(pendingApprovalGridFilters?.comment)
    } else if (activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      setCommentFilter(fleetProcessingGridFilters?.comment)
    } else if(activeMenu === HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      setCommentFilter(allPendingApprovalGridFilters?.comment)
    } else {
      setCommentFilter(myOrdersGridFilters?.comment)
    }
  }, [pendingApprovalGridFilters?.comment, myOrdersGridFilters?.comment, fleetProcessingGridFilters?.comment, allPendingApprovalGridFilters?.comment])

  useEffect(() => {
    if (serverTotal && paginationData?.pageSize) {
      let pageSize = paginationData?.pageSize
      let tempPageCount = serverTotal > pageSize ? Math.ceil(serverTotal / pageSize - 1) : 0
      setPagesCount(tempPageCount)
    }
  }, [serverTotal, paginationData?.pageSize])

  useEffect(() => {
    if (serverPageNumber === 1 && (paginationData?.pageIndex ?? 0) > 0) {
      setPaginationData((prev: any) => ({ ...prev, pageIndex: 0 }))
      setGridKey((k: number) => k + 1)
    }
  }, [serverPageNumber])

  useEffect(() => {
    if (approvers) {
      dispatchSetIsOrderApprovalComplete(false)
    }
  }, [approvers, JSON.stringify(orderListGridData?.assignedOrders)])

  useEffect(() => {
    if (fleetAdmin) {
      dispatchSetIsOrderApprovalComplete(false)
    }

  }, [fleetAdmin, JSON.stringify(orderListGridData?.assignedOrders)])

  useEffect(() => {
    if (userDetails?.emailId) {
      if (isAuthorized(permissions.ApprovalsView)) {
        setApprovers(true)
      }
      else if (userDetails?.role == 'Fleet Admin' || userDetails?.role == 'SuperAdmin') {
        setFleetAdmin(true)
      }
    }
  }, [JSON.stringify(userDetails), cartCount])

  useEffect(() => {
    if (props?.filteredOrderList?.length) {
      const updatedOrderList = props?.filteredOrderList?.map((item: any) => (
        {
          ...item,
          orderDate: Moment(item.orderDate).format('MM/DD/YYYY'),
          updatedDate: Moment(item.updatedDate).format('MM/DD/YYYY'),
          fleetItemStatus: item.fleetItemDetail?.map((i: any) => i.itemStatus),
          dispositionType: item.orderDispositionType?.map((i?: any) => i)
        }
      ))
      setFilteredOrderList(updatedOrderList);
    }
    else {
      setFilteredOrderList([]);
    }
  }, [props?.filteredOrderList])

  const onClickValue = (e?: any) => {
    e?.stopPropagation();
  }

  useEffect(() => {
    const dropdownList: any = allRequestTypeList?.map((item: any) => {
      return { label: item.orderRequestType, key: item.orderRequestType, value: item.orderRequestType, ...item }
    })
    setOrderRequestTypeTemp(dropdownList)
  }, [allRequestTypeList])

  useEffect(() => {
    const dropdownList: any = statusList?.map((item: any) => {
      return { label: item.text, key: item.value, ...item }
    })
    setOrderStatusTemp(dropdownList)
  }, [statusList])

  useEffect(() => {
    if (itemStatusList?.length) {
      let itemStatusOptionsTemp = itemStatusList?.map((status: any) => ({ ...status, label: status?.text, key: status?.value }))
      setItemStatusOptions(itemStatusOptionsTemp)
    }
  }, [itemStatusList])

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPaginationData(paginationData)
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ paginationData }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ paginationData }))
      } else if(props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL){
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ paginationData }))
      }else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ paginationData }))
      }
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortData(data);
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ sortData: data }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ sortData: data }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ sortData: data }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ sortData: data }))
      }
    }
  }, [dispatch, props?.activeMenu])

  return <PendingOrderGrid
    onOrderIdClicked={onOrderIdClicked}
    approvers={approvers}
    Data={filteredOrderList}
    BranchList={props?.BranchList}
    ordersStatus={orderStatusTemp}
    setApprovers={setApprovers}
    showGrid={props?.showGrid}
    myOrder={props?.myOrder}
    activeMenu={props.activeMenu}
    orderRequestType={orderRequestTypeTemp}
    onClickValue={onClickValue}
    pendingApprovalGridFilters={props.pendingApprovalGridFilters}
    allPendingApprovalGridFilters = {props?.allPendingApprovalGridFilters}
    myOrdersGridFilters={props.myOrdersGridFilters}
    fleetProcessingGridFilters={props.fleetProcessingGridFilters}
    updatedByList={updatedByTemp}
    assignedToList={assignedToTemp}
    requestedByList={requestedByTemp}
    regionList={regionTemp}
    costCenterList={costCenterTemp}
    itemStatusOptions={itemStatusOptions}
    fetchAction={fetchAction}
    userDetails={userDetails}
    paginationData={paginationData}
    orderDate={orderDate}
    updateDate={updateDate}
    selectStatus={selectStatus}
    selectRegion={selectRegion}
    selectRequsetType={selectRequsetType}
    selectPreAuthorizationFlag = {selectPreAuthorizationFlag}
    selectCostCenter={selectCostCenter}
    selectUpdatedBy={selectUpdatedBy}
    selectAssignedTo={selectAssignedTo}
    selectRequestedBy={selectRequestedBy}
    selectItemStatus={selectItemStatus}
    selectDispositionType = {selectDispositionType}
    serverTotal={serverTotal}
    pagesCount={pagesCount}
    gridKey={gridKey}
    activeHomeFilterState={props?.activeHomeFilterState}
    dispositionTypeList = {dispositionTypeList}
    buyerNameList = {buyerNameList}
    setSelectedDispositionKey = {setSelectedDispositionKey}
    isGridDataLoading={isGridDataLoading}
    isDropDownsLoading={isDropDownsLoading}
    setSelectedBuyerNameKey = {setSelectedBuyerNameKey}
    selectBuyerName = {selectBuyerName}
    setOrderPriceFilter = {setOrderPriceFilter}
    orderPriceFilterRef = {orderPriceFilterRef}
  />
}

export default PendingOrderGridContainer